//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalLocation',
  data() {
    return {
      isShown: false,
    }
  },
  computed: {
    locationAllowed() {
      return this.$store.state.locationAllowed
    }
  },
  watch: {
    locationAllowed(val, oldVal) {
      if(val == false) {
        this.$modal.show('modal-location')
      }
    }
  },
  methods: {
    beforeOpen (event) {
      window.dispatchEvent(new Event('resize'));
    },
    opened() {
      this.isShown = true
    },
    close() {
       this.$modal.hide('modal-location')
    }
  }
}
